export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5302.0936ec94.jpg";